__webpack_require__.p = "/rice/";